import api from "../service/validar.service";
import * as types from "./validar.actionTypes";
import formActions from "@common/store/form/form.actions";
import { takeEvery, call, put, select } from "redux-saga/effects";
import validarActions from "./validar.actions";
import validarSelector from "./validar.selectors";

export default workSaga;

function* workSaga() {
  yield takeEvery(types.VALIDATE, validate);
  yield takeEvery(types.GET_DADOS_AMBULANTE, getDadosAmbulante);
}

function* validate(action) {
  const { payload } = action;

  const state = yield select(validarSelector.validar);

  if (state.tokenRecaptcha) {
    const dto = {
      CpfCnpj: payload.CpfCnpj,
      Exercicio: parseInt(payload.Exercicio),
      InscricaoMunicipal: parseInt(payload.InscricaoMunicipal),
      CodigoVerificacao: parseInt(payload.CodigoVerificacao)
    };

    const result = yield call(api.validate, dto, {
      headers: { tokenRecaptcha: state.tokenRecaptcha }
    });
    yield put(validarActions.setDadosAmbulante(result.data));

    yield put(
      formActions.redirect("servicoEmpresa.crachaAmbulante.validar.result")
    );
  } else yield _alert.warning("É necessário validar o ReCaptcha.");
}

function* getDadosAmbulante(action) {
  const { payload } = action;
  const state = yield select(validarSelector.validar);

  const result = yield call(api.getDadosAmbulante, payload, {
    headers: { tokenRecaptcha: state.tokenRecaptcha }
  });

  yield put(validarActions.setDadosAmbulante(result.data));
}
